var _path, _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 473,
    height: 224,
    viewBox: "0 0 473 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9368_142512)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H461C467.627 0 473 5.37258 473 12V212C473 218.627 467.627 224 461 224H0V0Z",
    fill: "#F7F8FA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1200,
    fill: "#BB9F83"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9368_142512",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1600,
    height: 1200
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1200,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9368_142512)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -9.0625,
    width: 1135,
    height: 851.25,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.75 203.75C283.75 164.572 315.51 132.812 354.688 132.812C393.865 132.812 425.625 164.572 425.625 203.75V274.688H284.596C284.129 274.688 283.75 274.309 283.75 273.841V203.75Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.5 -80C567.5 -40.8223 535.74 -9.0625 496.562 -9.0625C496.562 -48.2402 528.322 -80 567.5 -80ZM425.625 61.875C425.625 22.6973 457.385 -9.0625 496.562 -9.0625C496.562 30.1152 464.803 61.875 425.625 61.875ZM496.562 -9.0625C457.385 -9.0625 425.625 -40.8223 425.625 -80C464.803 -80 496.562 -48.2402 496.562 -9.0625ZM496.562 -9.0625C535.74 -9.0625 567.5 22.6973 567.5 61.875C528.322 61.875 496.562 30.1152 496.562 -9.0625Z",
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.75 -9.0625C283.75 30.1152 251.99 61.875 212.812 61.875C212.812 22.6973 244.572 -9.0625 283.75 -9.0625Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.875 133.68C141.875 94.502 173.635 62.7422 212.812 62.7422C212.812 101.92 181.053 133.68 141.875 133.68Z",
    fill: "#111747"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.281 265.176C237.078 252.91 222.812 229.985 222.812 203.729C222.812 177.472 237.078 154.547 258.281 142.281C279.485 154.547 293.75 177.472 293.75 203.729C293.75 229.985 279.485 252.91 258.281 265.176Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.875 132.812C141.875 171.99 110.115 203.75 70.9375 203.75C70.9375 164.572 102.697 132.812 141.875 132.812Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -9.0625,
    width: 141.875,
    height: 141.875,
    rx: 70.9375,
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 274.688C0 235.51 31.7598 203.75 70.9375 203.75C70.9375 242.928 39.1777 274.688 0 274.688Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.75 -9.0625H425.625V61.875C425.625 101.053 393.865 132.812 354.688 132.812C315.51 132.812 283.75 101.053 283.75 61.875V-9.0625Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M354.688 61.875C354.688 22.6973 386.447 -9.0625 425.625 -9.0625C425.625 30.1152 393.865 61.875 354.688 61.875Z",
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.875 -80C141.875 -40.8223 110.115 -9.0625 70.9375 -9.0625C70.9375 -48.2402 102.697 -80 141.875 -80ZM141.875 61.875C102.697 61.875 70.9375 30.1152 70.9375 -9.0625C110.115 -9.0625 141.875 22.6973 141.875 61.875ZM0 -80C39.1777 -80 70.9375 -48.2402 70.9375 -9.0625C31.7598 -9.0625 0 -40.8223 0 -80ZM70.9375 -9.0625C70.9375 30.1152 39.1777 61.875 0 61.875C0 22.6973 31.7598 -9.0625 70.9375 -9.0625Z",
    fill: "#111747"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9368_142512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H461C467.627 0 473 5.37258 473 12V212C473 218.627 467.627 224 461 224H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImage);
export default __webpack_public_path__ + "static/media/Profile-image.951888858152137009428828f99320f9.svg";
export { ForwardRef as ReactComponent };